export default [
	{
    name: 'schedule',
    path: 'schedule',
    component (resolve) {
      require(['@/components/student/course/schedule'], resolve)
    },
    meta: {
      title: '课程表'
    }
  },
  {
    name: 'courseList',
    path: 'list',
    component (resolve) {
      require(['@/components/student/course/list'], resolve)
    },
    meta: {
      // keepAlive: true,
      title: '我的课程'
    }
  },
  {
    name: 'courseDetail',
    path: 'detail/:courseId/:classId',
    component (resolve) {
      require(['@/components/student/course/detail'], resolve)
    },
    meta: {
      title: '课程详情'
    }
  },
  {
    name: 'CourseDetail',
    path: 'course-detail/:courseId/:classId',
    redirect: 'course-detail/:courseId/:classId/teaching-content',
    component (resolve) {
      require(['@/components/student/course/CourseDetail'], resolve)
    },
    children: [
      {
        path: 'teaching-content',
        component (resolve) {
          require(['@/components/student/course/course-tab/TeachingContent'], resolve)
        },
        meta: {
          keepAlive: true,
        }
      },
      {
        path: 'class-report',
        component (resolve) {
          require(['@/components/student/course/course-tab/ClassReport'], resolve)
        },
        meta: {
          keepAlive: true,
        }
      },


      {
        path: 'report-card',
        component (resolve) {
          require(['@/components/student/course/course-tab/ReportCard'], resolve)
        },
        meta: {
          keepAlive: true,
        }
      },
      {
        path: 'group',
        component (resolve) {
          require(['@/components/student/course/course-tab/Group'], resolve)
        },
        meta: {
          keepAlive: true,
        }
      }
    ],
    meta: {
      keepAlive: true,
      title: '课程详情'
    }
  },
  {
    name: 'activityDetail',
    path: 'activity-detail/:coursewareBaseId/:classId',
    component (resolve) {
      require(['@/components/student/course/course-tab/ActivityDetail'], resolve)
    },
    meta: {
      title: '课程详情'
    }
  },
  {
    name: 'dstActivityDetail',
    path: 'dst-activity-detail/:coursewareBaseId/:classId/:taskId',
    component (resolve) {
      require(['@/components/student/course/course-tab/ActivityDetail'], resolve)
    },
    meta: {
      // title : '课程详情'
    }
  },
  {
    name: 'coursewareDetail',
    path: 'courseware-detail/:coursewareBaseId/:classId',
    component (resolve) {
      require(['@/components/student/course/course-tab/CoursewareDetail'], resolve)
    },
    meta: {
      // title : '课堂活动详情'
    }
  },
  {
    path: 'report/:courseId/:classId',
    component (resolve) {
      require(['@/components/student/course/report'], resolve)
    },
    meta: {
      title: '成绩单'
    }
  },
  {
    path: 'interaction/:courseId/:classId',
    component (resolve) {
      require(['@/components/student/course/interaction'], resolve)
    },
    meta: {
      title: '课堂互动'
    }
  },
  {
    path: 'task/:courseId/:classId',
    component (resolve) {
      require(['@/components/student/course/task'], resolve)
    },
    meta: {
      title: '线上活动'
    }
  },
  {
    path: 'attendance/:courseId/:classId',
    component (resolve) {
      require(['@/components/student/course/attendance'], resolve)
    },
    meta: {
      title: '考勤详情'
    }
  },
  // 增加pdf预览 + url预览
  {
    path: '/pdfView',
    component (resolve) {
      require(['@/frame/pdfView'], resolve)
    },
  },
  {
    path: '/previewUrl',
    component (resolve) {
      require(['@/frame/preview-url'], resolve)
    },
  }

]



// WEBPACK FOOTER //
// ./src/router/student/course.js